import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { MeetingsObject } from '@components/meetingModule/components';
import { useUserRoleType } from '@hooks/useUserRoleType';

export const useMeetingListRBDM = (): IQueryResponse<Array<MeetingsObject>> => {
	const userRole = useUserRoleType();
	const { isDbChecked, shouldFetch } = useCheckRxdb(userRole === 'RBDM' ? 'meeting_list_rbdm' : 'meeting_list');

	const fetchMeetingListData = async (): Promise<Array<MeetingsObject>> => {
		const apiEndpoint = userRole === 'RBDM' ? APICONFIG.MEETINGS_DETAILS_RBDM : APICONFIG.MEETINGS_DETAILS;
		const dbCollection = userRole === 'RBDM' ? 'meeting_list_rbdm' : 'meeting_list';

		const response = await APIService.getData<Array<MeetingsObject>>(apiEndpoint, {
			limit: '0',
		});

		if (response) {
			const data = response.map((item) => {
				return { ...item, id: item.id.toString() };
			});
			await setRxdb(dbCollection, data);
		}
		return response;
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['MeetingList', userRole],
		queryFn: fetchMeetingListData,
		enabled: isDbChecked && shouldFetch,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
